<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Renda Adicional</h1>
      <p>Você possui outra fonte de renda?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group">
            <input class="form-control form-control-lg" v-model="extra" id="extra" type="text" placeholder="R$" required v-mask="'money'"/>
          </div>
          <div class="form-check d-flex justify-content-center">
            <div class="checkboxContainer">
              <input type="checkbox" class="form-check-input" id="noOther" @click="noHaveOther">
              <span class="checkmark"></span>
            </div>
            <label class="form-check-label" for="noOther">Não possuo outra fonte de renda!</label>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .options,
  form {
    padding-top: 1rem;
  }

  .form-check {
    padding-bottom: 1rem;
  }
</style>


<script>
import Masker from '@/utils/masker'

export default {
  data() {
    const pessoal = this.currentUser.Pessoal
    return {
      hasOtherIncomeSources: true,
      extra: (pessoal && pessoal.ValorOutraFonteRenda) ? pessoal.ValorOutraFonteRenda.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    noHaveOther() {
      if(document.getElementById("noOther").checked) {
        document.getElementById("extra").removeAttribute("required", "");
        this.hasOtherIncomeSources = false
      } else {
        document.getElementById("extra").setAttribute("required", "");
        this.hasOtherIncomeSources = true
      }
      
    },
    checkVerify() {
       
    },
    onSubmit(e) {
      e.preventDefault()

      if(this.hasOtherIncomeSources) {
        this.currentUser.Pessoal.OutraFonteRenda = true;
        this.currentUser.Pessoal.ValorOutraFonteRenda = Number.parseFloat(Masker.unmaskMoney(this.extra))
      } else {
        this.currentUser.Pessoal.OutraFonteRenda = false;
        this.currentUser.Pessoal.ValorOutraFonteRenda = 0.0
      }

      this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
    }
  },
  mounted() {
    if(!this.currentUser.Pessoal.OutraFonteRenda) {
      document.getElementById('noOther').click();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/AdditionalIncomeStep.vue